import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Only en.json and nl.json exist in public/locales/. Without supportedLngs and load: "languageOnly",
    // the browser language detector sends region codes (e.g. nl-NL) to the HTTP backend, which requests
    // /locales/nl-NL.json. That file doesn't exist, so Apache's FallbackResource serves index.html,
    // and i18next fails to parse HTML as JSON.
    supportedLngs: ["en", "nl"],
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    load: "languageOnly",
    interpolation: { escapeValue: false },
    backend: { loadPath: "/locales/{{lng}}.json" },
  });

export default i18n;
